module.exports = __webpack_public_path__ + "0220ce17a258e61af2b6616e4f7d0bc4.svg";